<template>
  <p><slot /></p>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BmSubpageDescription",
});
</script>

<style scoped lang="sass">
@import "src/sass/typography"

p
  @include bm-body
  color: $bm-color-text01
</style>
